import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';
import { AppDate } from '../models/date.model';

export const US_LONG_FORMAT = 'MMM-DD-YYYY';
export const US_SHORT_FORMAT = 'MM-DD-YYYY';

@Pipe({
  name: 'dateFormat',
  standalone: false,
})
export class DateFormatPipe implements PipeTransform {
  constructor() {}

  transform(key: any, args?): string {
    let momentDate;
    let format = US_LONG_FORMAT;

    if (typeof key === 'string') {
      momentDate = dayjs(new Date(key));
    } else if (typeof key === 'number') {
      momentDate = dayjs(key);
    } else if (key instanceof Date) {
      momentDate = dayjs(key);
    } else if (key instanceof AppDate) {
      momentDate = key.date;

      if (args && args.indexOf(' formatAsLocal') > -1) {
        momentDate.utc();
        args = args.replace(' formatAsLocal', '');
      }
    } else if (key instanceof dayjs) {
      momentDate = key;
    }

    if (args && args === 'us-long') {
      format = US_LONG_FORMAT;
    } else if (args && args === 'us-short') {
      format = US_SHORT_FORMAT;
    } else if (args) {
      format = args;
    }
    return momentDate && momentDate.isValid()
      ? momentDate.format(format ? format : US_LONG_FORMAT)
      : '';
  }
}
